<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="666px"
    top="4vh"
    append-to-body
    :before-close="close"
  >
    <div slot="title">
      <title-icon />
      <span>定时任务</span>
    </div>
    <div class="rightCard">
      <div>
        <div
          :key="'1' + index"
          v-for="(timeList, index) in timeListWeek1"
          class="timeTable"
        >
          <div v-if="index == 0" class="line">{{ timeList.week }}</div>
          <div class="timeSelect">
            <div
              class="line"
              :style="index > 0 ? { 'text-indent': '2em' } : {}"
            >
              开启：
            </div>
            <div>
              <el-time-picker
                v-model="timeList.startTime"
                :picker-options="{
                  selectableRange: `${
                    index == 0 ? '00:00:00' : endTime + ':00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                @focus="timeStart(timeList)"
                @change="timeStartS"
                value-format="HH:mm"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 2em">关闭：</div>
            <div>
              <el-time-picker
                v-model="timeList.endTime"
                :picker-options="{
                  selectableRange: `${
                    startTime ? startTime + ':00' : '00:00:00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeEnd(timeList)"
                @change="timeEndS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 1em">
              <el-button
                size="mini"
                icon="el-icon-plus"
                circle
                @click.prevent="addTimeData(timeList)"
              ></el-button>
              <el-button
                v-if="index !== 0"
                size="mini"
                icon="el-icon-delete"
                circle
                @click.prevent="removeTimeData(timeList)"
              >
              </el-button>
            </div>
          </div>
        </div>
        <div
          :key="'2' + index"
          v-for="(timeList, index) in timeListWeek2"
          class="timeTable"
        >
          <div v-if="index == 0" class="line">{{ timeList.week }}</div>
          <div class="timeSelect">
            <div
              class="line"
              :style="index > 0 ? { 'text-indent': '2em' } : {}"
            >
              开启：
            </div>
            <div>
              <el-time-picker
                v-model="timeList.startTime"
                :picker-options="{
                  selectableRange: `${
                    index == 0 ? '00:00:00' : endTime + ':00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeStart(timeList)"
                @change="timeStartS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 2em">关闭：</div>
            <div>
              <el-time-picker
                v-model="timeList.endTime"
                :picker-options="{
                  selectableRange: `${
                    startTime ? startTime + ':00' : '00:00:00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeEnd(timeList)"
                @change="timeEndS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 1em">
              <el-button
                size="mini"
                icon="el-icon-plus"
                circle
                @click.prevent="addTimeData(timeList)"
              ></el-button>
              <el-button
                v-if="index !== 0"
                size="mini"
                icon="el-icon-delete"
                circle
                @click.prevent="removeTimeData(timeList)"
              >
              </el-button>
            </div>
          </div>
        </div>
        <div
          :key="'3' + index"
          v-for="(timeList, index) in timeListWeek3"
          class="timeTable"
        >
          <div v-if="index == 0" class="line">{{ timeList.week }}</div>
          <div class="timeSelect">
            <div
              class="line"
              :style="index > 0 ? { 'text-indent': '2em' } : {}"
            >
              开启：
            </div>
            <div>
              <el-time-picker
                v-model="timeList.startTime"
                :picker-options="{
                  selectableRange: `${
                    index == 0 ? '00:00:00' : endTime + ':00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeStart(timeList)"
                @change="timeStartS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 2em">关闭：</div>
            <div>
              <el-time-picker
                v-model="timeList.endTime"
                :picker-options="{
                  selectableRange: `${
                    startTime ? startTime + ':00' : '00:00:00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeEnd(timeList)"
                @change="timeEndS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 1em">
              <el-button
                size="mini"
                icon="el-icon-plus"
                circle
                @click.prevent="addTimeData(timeList)"
              ></el-button>
              <el-button
                v-if="index !== 0"
                size="mini"
                icon="el-icon-delete"
                circle
                @click.prevent="removeTimeData(timeList)"
              >
              </el-button>
            </div>
          </div>
        </div>
        <div
          :key="'4' + index"
          v-for="(timeList, index) in timeListWeek4"
          class="timeTable"
        >
          <div v-if="index == 0" class="line">{{ timeList.week }}</div>
          <div class="timeSelect">
            <div
              class="line"
              :style="index > 0 ? { 'text-indent': '2em' } : {}"
            >
              开启：
            </div>
            <div>
              <el-time-picker
                v-model="timeList.startTime"
                :picker-options="{
                  selectableRange: `${
                    index == 0 ? '00:00:00' : endTime + ':00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeStart(timeList)"
                @change="timeStartS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 2em">关闭：</div>
            <div>
              <el-time-picker
                v-model="timeList.endTime"
                :picker-options="{
                  selectableRange: `${
                    startTime ? startTime + ':00' : '00:00:00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeEnd(timeList)"
                @change="timeEndS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 1em">
              <el-button
                size="mini"
                icon="el-icon-plus"
                circle
                @click.prevent="addTimeData(timeList)"
              ></el-button>
              <el-button
                v-if="index !== 0"
                size="mini"
                icon="el-icon-delete"
                circle
                @click.prevent="removeTimeData(timeList)"
              >
              </el-button>
            </div>
          </div>
        </div>
        <div
          :key="'5' + index"
          v-for="(timeList, index) in timeListWeek5"
          class="timeTable"
        >
          <div v-if="index == 0" class="line">{{ timeList.week }}</div>
          <div class="timeSelect">
            <div
              class="line"
              :style="index > 0 ? { 'text-indent': '2em' } : {}"
            >
              开启：
            </div>
            <div>
              <el-time-picker
                v-model="timeList.startTime"
                :picker-options="{
                  selectableRange: `${
                    index == 0 ? '00:00:00' : endTime + ':00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeStart(timeList)"
                @change="timeStartS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 2em">关闭：</div>
            <div>
              <el-time-picker
                v-model="timeList.endTime"
                :picker-options="{
                  selectableRange: `${
                    startTime ? startTime + ':00' : '00:00:00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeEnd(timeList)"
                @change="timeEndS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 1em">
              <el-button
                size="mini"
                icon="el-icon-plus"
                circle
                @click.prevent="addTimeData(timeList)"
              ></el-button>
              <el-button
                v-if="index !== 0"
                size="mini"
                icon="el-icon-delete"
                circle
                @click.prevent="removeTimeData(timeList)"
              >
              </el-button>
            </div>
          </div>
        </div>
        <div
          :key="'6' + index"
          v-for="(timeList, index) in timeListWeek6"
          class="timeTable"
        >
          <div v-if="index == 0" class="line">{{ timeList.week }}</div>
          <div class="timeSelect">
            <div
              class="line"
              :style="index > 0 ? { 'text-indent': '2em' } : {}"
            >
              开启：
            </div>
            <div>
              <el-time-picker
                v-model="timeList.startTime"
                :picker-options="{
                  selectableRange: `${
                    index == 0 ? '00:00:00' : endTime + ':00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeStart(timeList)"
                @change="timeStartS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 2em">关闭：</div>
            <div>
              <el-time-picker
                v-model="timeList.endTime"
                :picker-options="{
                  selectableRange: `${
                    startTime ? startTime + ':00' : '00:00:00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeEnd(timeList)"
                @change="timeEndS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 1em">
              <el-button
                size="mini"
                icon="el-icon-plus"
                circle
                @click.prevent="addTimeData(timeList)"
              ></el-button>
              <el-button
                v-if="index !== 0"
                size="mini"
                icon="el-icon-delete"
                circle
                @click.prevent="removeTimeData(timeList)"
              >
              </el-button>
            </div>
          </div>
        </div>
        <div
          :key="'7' + index"
          v-for="(timeList, index) in timeListWeek7"
          class="timeTable"
        >
          <div v-if="index == 0" class="line">{{ timeList.week }}</div>
          <div class="timeSelect">
            <div
              class="line"
              :style="index > 0 ? { 'text-indent': '2em' } : {}"
            >
              开启：
            </div>
            <div>
              <el-time-picker
                v-model="timeList.startTime"
                :picker-options="{
                  selectableRange: `${
                    index == 0 ? '00:00:00' : endTime + ':00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeStart(timeList)"
                @change="timeStartS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 2em">关闭：</div>
            <div>
              <el-time-picker
                v-model="timeList.endTime"
                :picker-options="{
                  selectableRange: `${
                    startTime ? startTime + ':00' : '00:00:00'
                  }-23:59:59`,
                }"
                format="HH:mm"
                value-format="HH:mm"
                @focus="timeEnd(timeList)"
                @change="timeEndS"
                :placeholder="$t('commons.startTime')"
                style="width: 150px"
              ></el-time-picker>
            </div>
            <div style="text-indent: 1em">
              <el-button
                size="mini"
                icon="el-icon-plus"
                circle
                @click.prevent="addTimeData(timeList)"
              ></el-button>
              <el-button
                v-if="index !== 0"
                size="mini"
                icon="el-icon-delete"
                circle
                @click.prevent="removeTimeData(timeList)"
              >
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="submitBtn">
        <el-button type="danger" @click="submitForm"> 确认</el-button>
        <el-button type="info" @click="deleteForm">删除</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  findPointList
} from '@/api/business/base/tenant/rundata'
import {
  setTimePoint
} from '@/api/business/base/tenant/controlsource'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  props: {
    innerVisible: {
      type: Boolean,
      default: false
    },
    historyTable: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isShow() {
      return this.innerVisible
    }
  },
  watch: {
    isShow: function () {
      this.isShowDialog()
    }
  },
  data() {
    return {
      timeData: "",
      timeListWeek1: [{ week: "周一", startTime: null, endTime: null }],
      timeListWeek2: [{ week: "周二", startTime: null, endTime: null }],
      timeListWeek3: [{ week: "周三", startTime: null, endTime: null }],
      timeListWeek4: [{ week: "周四", startTime: null, endTime: null }],
      timeListWeek5: [{ week: "周五", startTime: null, endTime: null }],
      timeListWeek6: [{ week: "周六", startTime: null, endTime: null }],
      timeListWeek7: [{ week: "周日", startTime: null, endTime: null }],
      newTimeData: "",
      startTime: "",
      endTime: "",
      currentIndex: '',
      currentWeek: '',
      // checked:false,
    }
  },
  methods: {
    isShowDialog() {
      if (this.innerVisible) {
        this.timeListWeek1 = [{ week: "周一", startTime: null, endTime: null }];
        this.timeListWeek2 = [{ week: "周二", startTime: null, endTime: null }];
        this.timeListWeek3 = [{ week: "周三", startTime: null, endTime: null }];
        this.timeListWeek4 = [{ week: "周四", startTime: null, endTime: null }];
        this.timeListWeek5 = [{ week: "周五", startTime: null, endTime: null }];
        this.timeListWeek6 = [{ week: "周六", startTime: null, endTime: null }];
        this.timeListWeek7 = [{ week: "周日", startTime: null, endTime: null }];
        this.clickDeviceNode()
      }
    },
    close() {
      console.log(this.innerVisible)
      this.$emit('update:innerVisible', false)
    },
    //点击监控点位时获取该点位的日程数据，渲染日程表；
    clickDeviceNode() {

      findPointList({ "codeArray": this.historyTable }).then(valueList => {

        if (valueList) {
          if (valueList.length != 0) {
            this.timeData = valueList[0].value;
            this.initTimeData();
          }
        }
      });

    },
    //获取时间设置
    initTimeData() {
      this.timeListWeek1 = [{ week: "周一", startTime: null, endTime: null }];
      this.timeListWeek2 = [{ week: "周二", startTime: null, endTime: null }];
      this.timeListWeek3 = [{ week: "周三", startTime: null, endTime: null }];
      this.timeListWeek4 = [{ week: "周四", startTime: null, endTime: null }];
      this.timeListWeek5 = [{ week: "周五", startTime: null, endTime: null }];
      this.timeListWeek6 = [{ week: "周六", startTime: null, endTime: null }];
      this.timeListWeek7 = [{ week: "周日", startTime: null, endTime: null }];
      let objStr = this.timeData;
      if (objStr == null || objStr == '0') {
        return;
      }
      let objStrList = objStr.split(';');     //['1,true,8:00,9:00', '2,true,8:00,9:00']
      objStrList.map(v => {
        let timeObj = v.split(",");  //[1,true,8:00,9:00]
        if (timeObj[0] == 1) {
          if (this.timeListWeek1[0].startTime == null || this.timeListWeek1[0].endTime == null) {
            this.timeListWeek1.shift();
          }
          let startTime = timeObj[2];
          let endTime = timeObj[3];
          this.timeListWeek1.push({ "week": "周一", "startTime": startTime, "endTime": endTime, })
        } else if (timeObj[0] == 2) {
          if (this.timeListWeek2[0].startTime == null || this.timeListWeek2[0].endTime == null) {
            this.timeListWeek2.shift();
          }
          let startTime = timeObj[2];
          let endTime = timeObj[3];
          this.timeListWeek2.push({ "week": "周二", "startTime": startTime, "endTime": endTime, })
        } else if (timeObj[0] == 3) {
          if (this.timeListWeek3[0].startTime == null || this.timeListWeek3[0].endTime == null) {
            this.timeListWeek3.shift();
          }
          let startTime = timeObj[2];
          let endTime = timeObj[3];
          this.timeListWeek3.push({ "week": "周三", "startTime": startTime, "endTime": endTime, })
        } else if (timeObj[0] == 4) {
          if (this.timeListWeek4[0].startTime == null || this.timeListWeek4[0].endTime == null) {
            this.timeListWeek4.shift();
          }
          let startTime = timeObj[2];
          let endTime = timeObj[3];
          this.timeListWeek4.push({ "week": "周四", "startTime": startTime, "endTime": endTime, })
        } else if (timeObj[0] == 5) {
          if (this.timeListWeek5[0].startTime == null || this.timeListWeek5[0].endTime == null) {
            this.timeListWeek5.shift();
          }
          let startTime = timeObj[2];
          let endTime = timeObj[3];
          this.timeListWeek5.push({ "week": "周五", "startTime": startTime, "endTime": endTime, })
        } else if (timeObj[0] == 6) {
          if (this.timeListWeek6[0].startTime == null || this.timeListWeek6[0].endTime == null) {
            this.timeListWeek6.shift();
          }
          let startTime = timeObj[2];
          let endTime = timeObj[3];
          this.timeListWeek6.push({ "week": "周六", "startTime": startTime, "endTime": endTime, })
        } else if (timeObj[0] == 7) {
          if (this.timeListWeek7[0].startTime == null || this.timeListWeek7[0].endTime == null) {
            this.timeListWeek7.shift();
          }
          let startTime = timeObj[2];
          let endTime = timeObj[3];
          this.timeListWeek7.push({ "week": "周日", "startTime": startTime, "endTime": endTime, })
        }


      });
    },


    //当设定的前一段日程的结束时间小于后一段的开始时间，则清空后面的日程设定
    timeStart(item) {
      this.currentWeek = item.week;
      if (item.week == "周一") {
        let outIndex = this.timeListWeek1.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        if (outIndex > 0) {
          this.endTime = this.timeListWeek1[outIndex - 1].endTime
        }
      }
      if (item.week == "周二") {
        let outIndex = this.timeListWeek2.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        if (outIndex > 0) {
          this.endTime = this.timeListWeek2[outIndex - 1].endTime
        }
      }
      if (item.week == "周三") {
        let outIndex = this.timeListWeek3.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        if (outIndex > 0) {
          this.endTime = this.timeListWeek3[outIndex - 1].endTime
        }
      }
      if (item.week == "周四") {
        let outIndex = this.timeListWeek4.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        if (outIndex > 0) {
          this.endTime = this.timeListWeek4[outIndex - 1].endTime
        }
      }
      if (item.week == "周五") {
        let outIndex = this.timeListWeek5.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        if (outIndex > 0) {
          this.endTime = this.timeListWeek5[outIndex - 1].endTime
        }
      }
      if (item.week == "周六") {
        let outIndex = this.timeListWeek6.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        if (outIndex > 0) {
          this.endTime = this.timeListWeek6[outIndex - 1].endTime
        }
      }
      if (item.week == "周日") {
        let outIndex = this.timeListWeek7.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        if (outIndex > 0) {
          this.endTime = this.timeListWeek7[outIndex - 1].endTime
        }
      }

    },
    //暂存日程表当前设定的开始时间
    timeStartS(value) {
      this.startTime = value;

      if (this.currentWeek == "周一") {
        if (this.startTime >= this.timeListWeek1[this.currentIndex].endTime) {
          this.timeListWeek1[this.currentIndex].endTime = null
          this.timeListWeek1.map((item, index) => {
            if (index > this.currentIndex) {
              item.startTime = null;
              item.endTime = null;
            }

          })
        }
      }
      if (this.currentWeek == "周二") {
        if (this.startTime >= this.timeListWeek2[this.currentIndex].endTime) {
          this.timeListWeek2[this.currentIndex].endTime = null
          this.timeListWeek2.map((item, index) => {
            if (index > this.currentIndex) {
              item.startTime = null;
              item.endTime = null;
            }

          })
        }
      }
      if (this.currentWeek == "周三") {
        if (this.startTime >= this.timeListWeek3[this.currentIndex].endTime) {
          this.timeListWeek3[this.currentIndex].endTime = null
          this.timeListWeek3.map((item, index) => {
            if (index > this.currentIndex) {
              item.startTime = null;
              item.endTime = null;
            }

          })
        }
      }
      if (this.currentWeek == "周四") {
        if (this.startTime >= this.timeListWeek4[this.currentIndex].endTime) {
          this.timeListWeek4[this.currentIndex].endTime = null
          this.timeListWeek4.map((item, index) => {
            if (index > this.currentIndex) {
              item.startTime = null;
              item.endTime = null;
            }

          })
        }
      }
      if (this.currentWeek == "周五") {
        if (this.startTime >= this.timeListWeek5[this.currentIndex].endTime) {
          this.timeListWeek5[this.currentIndex].endTime = null
          this.timeListWeek5.map((item, index) => {
            if (index > this.currentIndex) {
              item.startTime = null;
              item.endTime = null;
            }

          })
        }
      }
      if (this.currentWeek == "周六") {
        if (this.startTime >= this.timeListWeek6[this.currentIndex].endTime) {
          this.timeListWeek6[this.currentIndex].endTime = null
          this.timeListWeek6.map((item, index) => {
            if (index > this.currentIndex) {
              item.startTime = null;
              item.endTime = null;
            }

          })
        }
      }
      if (this.currentWeek == "周日") {
        if (this.startTime >= this.timeListWeek7[this.currentIndex].endTime) {
          this.timeListWeek7[this.currentIndex].endTime = null
          this.timeListWeek7.map((item, index) => {
            if (index > this.currentIndex) {
              item.startTime = null;
              item.endTime = null;
            }

          })
        }
      }

    },
    //当设定的前一段日程的结束时间小于后一段的开始时间，则清空后面的日程设定
    timeEnd(item) {
      this.currentWeek = item.week;
      if (item.week == "周一") {
        let outIndex = this.timeListWeek1.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        this.startTime = this.timeListWeek1[outIndex].startTime
      }
      if (item.week == "周二") {
        let outIndex = this.timeListWeek2.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        this.startTime = this.timeListWeek2[outIndex].startTime
      }
      if (item.week == "周三") {
        let outIndex = this.timeListWeek3.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        this.startTime = this.timeListWeek3[outIndex].startTime
      }
      if (item.week == "周四") {
        let outIndex = this.timeListWeek4.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        this.startTime = this.timeListWeek4[outIndex].startTime
      }
      if (item.week == "周五") {
        let outIndex = this.timeListWeek5.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        this.startTime = this.timeListWeek5[outIndex].startTime
      }
      if (item.week == "周六") {
        let outIndex = this.timeListWeek6.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        this.startTime = this.timeListWeek6[outIndex].startTime
      }
      if (item.week == "周日") {
        let outIndex = this.timeListWeek7.findIndex((obj) => obj == item);
        this.currentIndex = outIndex;
        this.startTime = this.timeListWeek7[outIndex].startTime
      }

    },
    //暂存日程表当前设定的结束时间
    timeEndS(value) {
      this.endTime = value;

      if (this.currentWeek == "周一") {
        if (this.timeListWeek1[this.currentIndex + 1]) {
          if (this.endTime >= this.timeListWeek1[this.currentIndex + 1].startTime) {
            this.timeListWeek1.map((item, index) => {
              if (index > this.currentIndex) {
                item.startTime = null;
                item.endTime = null;
              }

            })
          }
        }
      }
      if (this.currentWeek == "周二") {
        if (this.timeListWeek2[this.currentIndex + 1]) {
          if (this.endTime >= this.timeListWeek2[this.currentIndex + 1].startTime) {
            this.timeListWeek2.map((item, index) => {
              if (index > this.currentIndex) {
                item.startTime = null;
                item.endTime = null;
              }

            })
          }
        }
      }
      if (this.currentWeek == "周三") {
        if (this.timeListWeek3[this.currentIndex + 1]) {
          if (this.endTime >= this.timeListWeek3[this.currentIndex + 1].startTime) {
            this.timeListWeek3.map((item, index) => {
              if (index > this.currentIndex) {
                item.startTime = null;
                item.endTime = null;
              }

            })
          }
        }
      }
      if (this.currentWeek == "周四") {
        if (this.timeListWeek4[this.currentIndex + 1]) {
          if (this.endTime >= this.timeListWeek4[this.currentIndex + 1].startTime) {
            this.timeListWeek4.map((item, index) => {
              if (index > this.currentIndex) {
                item.startTime = null;
                item.endTime = null;
              }

            })
          }
        }
      }
      if (this.currentWeek == "周五") {
        if (this.timeListWeek5[this.currentIndex + 1]) {
          if (this.endTime >= this.timeListWeek5[this.currentIndex + 1].startTime) {
            this.timeListWeek5.map((item, index) => {
              if (index > this.currentIndex) {
                item.startTime = null;
                item.endTime = null;
              }

            })
          }
        }
      }
      if (this.currentWeek == "周六") {
        if (this.timeListWeek6[this.currentIndex + 1]) {
          if (this.endTime >= this.timeListWeek6[this.currentIndex + 1].startTime) {
            this.timeListWeek6.map((item, index) => {
              if (index > this.currentIndex) {
                item.startTime = null;
                item.endTime = null;
              }

            })
          }
        }
      }
      if (this.currentWeek == "周日") {
        if (this.timeListWeek7[this.currentIndex + 1]) {
          if (this.endTime >= this.timeListWeek7[this.currentIndex + 1].startTime) {
            this.timeListWeek7.map((item, index) => {
              if (index > this.currentIndex) {
                item.startTime = null;
                item.endTime = null;
              }

            })
          }
        }
      }
    },


    //删除日程设定的某一段
    removeTimeData(item) {
      if (item.week == "周一") {
        let index = this.timeListWeek1.indexOf(item)
        if (index !== -1) {
          this.timeListWeek1.splice(index, 1)
        }
      } else if (item.week == "周二") {
        let index = this.timeListWeek2.indexOf(item)
        if (index !== -1) {
          this.timeListWeek2.splice(index, 1)
        }
      } else if (item.week == "周三") {
        let index = this.timeListWeek3.indexOf(item)
        if (index !== -1) {
          this.timeListWeek3.splice(index, 1)
        }
      } else if (item.week == "周四") {
        let index = this.timeListWeek4.indexOf(item)
        if (index !== -1) {
          this.timeListWeek4.splice(index, 1)
        }
      } else if (item.week == "周五") {
        let index = this.timeListWeek5.indexOf(item)
        if (index !== -1) {
          this.timeListWeek5.splice(index, 1)
        }
      } else if (item.week == "周六") {
        let index = this.timeListWeek6.indexOf(item)
        if (index !== -1) {
          this.timeListWeek6.splice(index, 1)
        }
      } else if (item.week == "周日") {
        let index = this.timeListWeek7.indexOf(item)
        if (index !== -1) {
          this.timeListWeek7.splice(index, 1)
        }
      }

    },
    //添加一段日程设定
    addTimeData(item) {
      if (item.week == "周一") {
        if (this.timeListWeek1[0].startTime == null || this.timeListWeek1[0].endTime == null) {
          this.$message('请完成设定');
        } else {
          this.timeListWeek1.push({
            week: "周一",
            startTime: null,
            endTime: null,
          });
        }

      } else if (item.week == "周二") {
        if (this.timeListWeek2[0].startTime == null || this.timeListWeek2[0].endTime == null) {
          this.$message('请完成设定');
        } else {
          this.timeListWeek2.push({
            week: "周二",
            startTime: null,
            endTime: null,
          });
        }
      } else if (item.week == "周三") {
        if (this.timeListWeek3[0].startTime == null || this.timeListWeek3[0].endTime == null) {
          this.$message('请完成设定');
        } else {
          this.timeListWeek3.push({
            week: "周三",
            startTime: null,
            endTime: null,
          });
        }
      } else if (item.week == "周四") {
        if (this.timeListWeek4[0].startTime == null || this.timeListWeek4[0].endTime == null) {
          this.$message('请完成设定');
        } else {
          this.timeListWeek4.push({
            week: "周四",
            startTime: null,
            endTime: null,
          });
        }
      } else if (item.week == "周五") {
        if (this.timeListWeek5[0].startTime == null || this.timeListWeek5[0].endTime == null) {
          this.$message('请完成设定');
        } else {
          this.timeListWeek5.push({
            week: "周五",
            startTime: null,
            endTime: null,
          });
        }
      } else if (item.week == "周六") {
        if (this.timeListWeek6[0].startTime == null || this.timeListWeek6[0].endTime == null) {
          this.$message('请完成设定');
        } else {
          this.timeListWeek6.push({
            week: "周六",
            startTime: null,
            endTime: null,
          });
        }
      } else {
        if (this.timeListWeek7[0].startTime == null || this.timeListWeek7[0].endTime == null) {
          this.$message('请完成设定');
        } else {
          this.timeListWeek7.push({
            week: "周日",
            startTime: null,
            endTime: null,
          });
        }
      }

    },
    //确认下发日程设定
    submitForm() {
      if (this.historyTable.length > 0) {
        this.timeListWeek1.map((item, index) => {
          //检验除第一行有没有设定
          if (index == 0) {
            if (item.startTime == null || item.endTime == null) {
              return this.newTimeData
            } else {
              this.newTimeData += "1,true," + item.startTime + "," + item.endTime + ";"
            }

          }
          //检验除第一行以外的，如果开始时间或者结束时间没有设定，则不下发这条设定
          if (index > 0) {
            if (item.startTime !== null && item.endTime !== null) {
              this.newTimeData += "1,true," + item.startTime + "," + item.endTime + ";"
            }
          }
        })

        this.timeListWeek2.map((item, index) => {
          if (index == 0) {
            if (item.startTime == null || item.endTime == null) {
              return this.newTimeData
            } else {
              this.newTimeData += "2,true," + item.startTime + "," + item.endTime + ";"
            }

          }
          if (index > 0) {
            if (item.startTime !== null && item.endTime !== null) {
              this.newTimeData += "2,true," + item.startTime + "," + item.endTime + ";"
            }
          }
        })
        this.timeListWeek3.map((item, index) => {
          if (index == 0) {
            if (item.startTime == null || item.endTime == null) {
              return this.newTimeData
            } else {
              this.newTimeData += "3,true," + item.startTime + "," + item.endTime + ";"
            }

          }
          if (index > 0) {
            if (item.startTime !== null && item.endTime !== null) {
              this.newTimeData += "3,true," + item.startTime + "," + item.endTime + ";"
            }
          }
        })
        this.timeListWeek4.map((item, index) => {
          if (index == 0) {
            if (item.startTime == null || item.endTime == null) {
              return this.newTimeData
            } else {
              this.newTimeData += "4,true," + item.startTime + "," + item.endTime + ";"
            }

          }
          if (index > 0) {
            if (item.startTime !== null && item.endTime !== null) {
              this.newTimeData += "4,true," + item.startTime + "," + item.endTime + ";"
            }
          }
        })
        this.timeListWeek5.map((item, index) => {
          if (index == 0) {
            if (item.startTime == null || item.endTime == null) {
              return this.newTimeData
            } else {
              this.newTimeData += "5,true," + item.startTime + "," + item.endTime + ";"
            }

          }
          if (index > 0) {
            if (item.startTime !== null && item.endTime !== null) {
              this.newTimeData += "5,true," + item.startTime + "," + item.endTime + ";"
            }
          }
        })
        this.timeListWeek6.map((item, index) => {
          if (index == 0) {
            if (item.startTime == null || item.endTime == null) {
              return this.newTimeData
            } else {
              this.newTimeData += "6,true," + item.startTime + "," + item.endTime + ";"
            }

          }
          if (index > 0) {
            if (item.startTime !== null && item.endTime !== null) {
              this.newTimeData += "6,true," + item.startTime + "," + item.endTime + ";"
            }
          }
        })
        this.timeListWeek7.map((item, index) => {
          if (index == 0) {
            if (item.startTime == null || item.endTime == null) {
              return this.newTimeData
            } else {
              this.newTimeData += "7,true," + item.startTime + "," + item.endTime + ";"
            }

          }
          if (index > 0) {
            if (item.startTime !== null && item.endTime !== null) {
              this.newTimeData += "7,true," + item.startTime + "," + item.endTime + ";"
            }
          }
        });

        //下发日程表
        setTimePoint({ "sourceCodeList": this.historyTable, "value": this.newTimeData }).then(() => {
          this.$message('下发成功');
          this.newTimeData = ''
        }).catch(() => {
          this.$message.error('下发失败！');
        });
      } else {
        this.$message('请选择设备点位');
      }
    },
    //清空日程设定，并下发  0
    deleteForm() {
      if (this.historyTable.length > 0) {
        this.timeListWeek1 = [{ week: "周一", startTime: null, endTime: null }];
        this.timeListWeek2 = [{ week: "周二", startTime: null, endTime: null }];
        this.timeListWeek3 = [{ week: "周三", startTime: null, endTime: null }];
        this.timeListWeek4 = [{ week: "周四", startTime: null, endTime: null }];
        this.timeListWeek5 = [{ week: "周五", startTime: null, endTime: null }];
        this.timeListWeek6 = [{ week: "周六", startTime: null, endTime: null }];
        this.timeListWeek7 = [{ week: "周日", startTime: null, endTime: null }];


        //点击删除时下发 0
        setTimePoint({ "sourceCodeList": this.historyTable, "value": "0" }).then(() => {
          this.$message('下发成功');
          this.newTimeData = ''
        }).catch((error) => {
          this.$message(`下发失败，原因 => ${error}`)
        });
      } else {
        this.$message('请选择设备点位');
      }
    }


  }
}
</script>

<style lang="scss">
.rightCard {
  height: 420px;
  div {
    display: inline-block;
  }

  .timeSelect {
    height: 45px;
    margin-left: 50px;
  }

  .submitBtn {
    margin-top: 30px;
    margin-right: 60px;
    float: right;
  }
}
</style>
